import { Record, Set as ImmutableSet } from 'immutable';
import { API_KNOWN_KEY_MAPPINGS, API_KNOWN_VALUE_MAPPINGS, API_IDENTIFIER_MAPPINGS, OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID } from '../Constants';
export default class LookupRecord extends Record({
  type: undefined,
  primaryIdentifier: undefined,
  secondaryIdentifier: undefined,
  fileManagerKey: undefined,
  dimensions: undefined,
  portalId: undefined
}, 'LookupRecord') {
  isKnown() {
    return this.type !== undefined && this.type in API_KNOWN_KEY_MAPPINGS;
  }
  isKnownTypeIdentifier() {
    return this.type !== undefined && this.type in API_IDENTIFIER_MAPPINGS;
  }
  getKnownName() {
    if (!this.isKnown()) {
      return undefined;
    }
    return API_KNOWN_KEY_MAPPINGS[this.type];
  }
  getKnownObject() {
    if (!this.isKnown()) {
      return undefined;
    }
    return {
      [API_KNOWN_VALUE_MAPPINGS[this.type].primaryIdentifier]: this.primaryIdentifier,
      [API_KNOWN_VALUE_MAPPINGS[this.type].secondaryIdentifier]: this.secondaryIdentifier,
      fileManagerKey: this.fileManagerKey
    };
  }
  getIdentifierName() {
    if (!this.isKnownTypeIdentifier()) {
      return undefined;
    }
    return API_IDENTIFIER_MAPPINGS[this.type];
  }
  getIdentifier() {
    return this.primaryIdentifier;
  }
  isSameAs(lookup) {
    var _this$type, _lookup$type, _this$type2, _lookup$type2;
    if (this.type === lookup.type) {
      return this.primaryIdentifier === lookup.primaryIdentifier;
    }
    const haveVid = ImmutableSet.of('contact', 'vid').has((_this$type = this.type) !== null && _this$type !== void 0 ? _this$type : '') && ImmutableSet.of('contact', 'vid').has((_lookup$type = lookup.type) !== null && _lookup$type !== void 0 ? _lookup$type : '');
    const haveCompanyId = ImmutableSet.of('company', 'companyId').has((_this$type2 = this.type) !== null && _this$type2 !== void 0 ? _this$type2 : '') && ImmutableSet.of('company', 'companyId').has((_lookup$type2 = lookup.type) !== null && _lookup$type2 !== void 0 ? _lookup$type2 : '');
    if (haveVid || haveCompanyId) {
      return this.primaryIdentifier === lookup.primaryIdentifier;
    }
    if (this.type === 'contact' && lookup.type === 'email' || this.type === 'company' && lookup.type === 'domain') {
      return this.secondaryIdentifier === lookup.primaryIdentifier;
    }
    if (this.type === 'email' && lookup.type === 'contact' || this.type === 'domain' && lookup.type === 'company') {
      return this.primaryIdentifier === lookup.secondaryIdentifier;
    }
    return false;
  }
  requiresPortalId() {
    return this.type && OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID.indexOf(this.type) > -1;
  }
}